import { useState, useEffect, useRef } from 'react'
import { ESortOrder } from '../components'
import { useSearchParams } from 'react-router'
import * as lib from '../lib'

export const OFFER_SPEND_BY_ACCOUNT_PAGE_SORT_FIELDS = ['accountId', 'account.auth.login', 'account.extra.keitaroLogin', 'amount'] as const

export type IOfferSpendByAccountSortField = typeof OFFER_SPEND_BY_ACCOUNT_PAGE_SORT_FIELDS[number]

type IUseOfferSpendByAccountSortPage = {
	sortBy: IOfferSpendByAccountSortField;
	setSortBy: (value: (((prevState: IOfferSpendByAccountSortField) => IOfferSpendByAccountSortField) | IOfferSpendByAccountSortField)) => void;
	order: ESortOrder;
	setOrder: (value: (((prevState: ESortOrder) => ESortOrder) | ESortOrder)) => void;
}

const DEFAULT_SORT_BY: IOfferSpendByAccountSortField = 'accountId'
const DEFAULT_SORT_ORDER: ESortOrder = ESortOrder.desc
export const useOfferSpendByAccountSortPage = (): IUseOfferSpendByAccountSortPage => {
	const isFirstRender = useRef<boolean>(true)
	const [searchParams, setSearchParams] = useSearchParams()

	const urlSort = (() => {
		try {
			return lib.sortSearchParams(searchParams.get('s')) ?? []
		} catch (error) {
			console.error(error)
			return []
		}
	})().filter((item) => {
		const sortOrderValues = Object.values(ESortOrder)

		return OFFER_SPEND_BY_ACCOUNT_PAGE_SORT_FIELDS.includes(item[0] as IOfferSpendByAccountSortField) && sortOrderValues.includes(item[1] as ESortOrder)
	})

	const [sortBy, setSortBy] = useState<IOfferSpendByAccountSortField>(urlSort?.[0]?.[0] as IOfferSpendByAccountSortField ?? DEFAULT_SORT_BY)
	const [order, setOrder] = useState<ESortOrder>(urlSort?.[0]?.[1] as ESortOrder ?? DEFAULT_SORT_ORDER)
	// const [send, setSend] = useState<boolean>(false)
	//console.log('useOfferSpendByAccountSortPage:: ', { sortUrl: urlSort })

	useEffect(() => {
		let _sortBy = sortBy
		let _order = order

		if (_sortBy && _order) {
			const newSortStr = lib.sortSetup([[_sortBy, _order]])

			setSearchParams((prev) => {
				if (!isFirstRender.current) {
					if (_order !== ESortOrder.unset) {
						prev.set('s', newSortStr)
					} else {
						prev.delete('s')
					}
				} else {
					isFirstRender.current = false
				}

				return prev
			})
		}
	}, [sortBy, order])

	return {
		sortBy,
		setSortBy,
		order,
		setOrder
	}
}